module.exports = __webpack_public_path__ + "img/icon56.5a412484.png";